export enum CustomFilterType {
  TRANSPORT_LIST = 'TRANSPORT_LIST', VISITOR_LIST = 'VISITOR_LIST'
}

export class CustomFilter {

  id: number;
  externalKey: string;
  dictionaryKey: string;
  type: CustomFilterType;
  tableColumns: string;
  sortColumn: string;
  sortDescending: boolean;
  displayOnly = false;

  constructor(filter: CustomFilter) {
    this.id = filter.id;
    this.externalKey = filter.externalKey;
    this.dictionaryKey = filter.dictionaryKey;
    this.type = filter.type;
    this.tableColumns = filter.tableColumns;
    this.sortColumn = filter.sortColumn;
    this.sortDescending = filter.sortDescending;
    this.displayOnly = filter.displayOnly === true;
  }
}
